/* Exact Watch model/color links remain server-rendered and work without JS. */
if (!customElements.get('evolved-watch-bands')) {
  customElements.define('evolved-watch-bands', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const init = () => {
        if (!this.isConnected) return;
        this.select = this.querySelector('[data-watch-model]');
        this.panels = [...this.querySelectorAll('[data-watch-color-panel]')];
        if (!this.select || !this.panels.length) return;
        const readHash = () => {
          const params = new URLSearchParams(location.hash.slice(1));
          const size = params.get('watch-size');
          const option = [...this.select.options].find(item => item.dataset.size === size);
          if (option) this.select.value = option.value;
          this.update(false);
        };
        this.select.addEventListener('change', () => this.update(true), {signal});
        window.addEventListener('hashchange', readHash, {signal});
        readHash();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true,signal});
      else init();
    }
    update(changed) {
      const option = this.select.selectedOptions[0];
      if (!option) return;
      this.panels.forEach(panel => { panel.hidden = panel.dataset.watchColorPanel !== option.value; });
      const active = this.panels.find(panel => !panel.hidden);
      const destination = new URL(this.dataset.bandsUrl, location.href);
      destination.hash = 'watch-size=' + encodeURIComponent(option.dataset.size);
      this.closest('.ev-watch-guide')?.querySelectorAll('[data-watch-all]').forEach(link => { link.href = destination.pathname + destination.search + destination.hash; });
      active?.querySelectorAll('evolved-rail-controls').forEach(controls => controls.scheduleUpdate?.());
      if (changed) {
        const status = this.querySelector('[data-watch-status]');
        if (status) status.textContent = `${active?.dataset.colorCount || 0} colors for ${option.textContent.trim()}`;
        if (this.dataset.fullCollection === 'true') {
          try { const url = new URL(location.href); url.hash = destination.hash; history.replaceState(history.state, '', url); } catch (_) {}
        }
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
